var moment = require('moment')

import { URL_UPLOAD } from '../config/config.js'
import { PROPERTY_ITEMS } from '../config/property_items/property_items.js'

export default {

    fullCommercialAddress(object){
        if(!object) return ''
        
        var address = '';
        address += object.endereco_publicidade; 
        
        if(object.numero_publicidade && object.numero_publicidade > 0){
            address += ', ' + object.numero_publicidade;
        }

        if(object.bairro_publicidade && object.bairro_publicidade != null && object.bairro_publicidade != ''){
            address += ' - ' + object.bairro;
        }

        if(object.cidade_publicidade && object.cidade_publicidade != null && object.cidade_publicidade != ''){
            address += ' - ' + object.cidade_publicidade;
        }

        if(object.estado_publicidade && object.estado_publicidade != null && object.estado_publicidade != ''){
            address += ' - ' + object.estado_publicidade;
        }

        if(object.cep_publicidade && object.cep_publicidade != null && object.cep_publicidade != ''){
            // Aplica máscara no CEP manualmente
            const formatarCep = (cep) => {
                if (!cep) return '';
                const cepLimpo = cep.toString().replace(/\D/g, '');
                return cepLimpo.replace(/^(\d{5})(\d{3})$/, '$1-$2');
            };

            address += ' - CEP: ' + formatarCep(object.cep_publicidade);
        }
        return address;
    },
    
    fullAddress(object){
        if(!object) return ''
        
        var address = '';
        address += object.endereco; 
        
        if(object.numero && object.numero > 0){
            address += ', ' + object.numero;
        }
        
        if(object.apartamento && object.apartamento > 0){
            address += ' - Apto: ' + object.apartamento;
        }

        if(object.andar && object.andar > 0){
            address += ' - ' + object.andar + ' andar';
        }

        if(object.tower_id && object.tower_id != null && object.tower && object.tower.nome != ''){
            address += ' - Torre:' + object.tower.nome;
        }

        if(object.complemento && object.complemento != ''){
            address += ' - Complemento:' + object.complemento;
        }

        if(object.position_id && object.position_id != null && object.position.nome != ''){
            address += ' - Posiçāo:' + object.position.nome;
        }

        if(object.bairro && object.bairro != null && object.bairro != ''){
            address += ' - ' + object.bairro;
        }

        if(object.cidade && object.cidade != null && object.cidade != ''){
            address += ' - ' + object.cidade;
        }

        if(object.estado && object.estado != null && object.estado != ''){
            address += ' - ' + object.estado;
        }

        if(object.cep && object.cep != null && object.cep != ''){
            // Aplica máscara no CEP manualmente
            const formatarCep = (cep) => {
                if (!cep) return '';
                const cepLimpo = cep.toString().replace(/\D/g, '');
                return cepLimpo.replace(/^(\d{5})(\d{3})$/, '$1-$2');
            };

            address += ' - CEP: ' + formatarCep(object.cep);
        }

        if(object.condominio_avulso && object.condominio_avulso != null && object.condominio_avulso != ''){
            address += ' - Condomínio: ' + object.condominio_avulso;
        }

        if(object.condominium && object.condominium.nome != ''){
            address += ' - Condomínio: ' + object.condominium.nome;
        }
        
        if(object.zona && object.zona != null && object.zona != ''){
            address += ' - Zona: ' + object.zona;
        }

        return address;
    },

    statusOpenClosed (value) {
        if(!value) return ''
        if(value == 'Open') return 'red'
        else if(value == 'Closed') return 'green'
        else return ''
    },

    onlyNumber(str) {
        return str.replace(/[^0-9]+/g, '')
    },

    urlUpload(param){
        return URL_UPLOAD + param
    },

    formatDate (date) {
        if(date != '' && date != null){
            return moment(String(date)).format( 'DD/MM/YYYY')
        }else{
            return ''
        }  
    },

    statusDueDate (item) {
        if(!item.due_date) return ''

        const result = {};
        var date = moment(item.due_date)
        var now = moment()

        const diff = now.diff(date, 'days')

        if (diff > 0) {
            result.color = '#F8BBD0'
            result.description = 'Vencido'
        }else{
            result.color = '#FFE0B2'
            result.description = 'A vencer'
        }
        
        if(item.payment_date != null){
            result.color = '#DCEDC8'
            result.description = 'Pago'
        }
        return result
    },

    formatDateTime (date) {
        if(date != '' && date != null){
            return moment(String(date)).format('DD/MM/YYYY H:mm:ss')
        }else{
            return ''
        }  
    },

    formatDate2 (date) {
        if(date != '' && date != null){
            return moment(String(date)).format('YYYYMMDD')
        }else{
            return ''
        }  
    },

    

    filterPropertyItems(search){
        if(search.model && search.model != '' && search.model != undefined){
            var results = PROPERTY_ITEMS.filter(model => model.model == search.model)
            if(search.tipos && search.tipos != ''){
                var tipos = []
                results.forEach(i => {
                    var item = i.tipos.includes(search.tipos)
                    if(item == true){
                        tipos.push(i)
                    }
                })
                results = tipos 
            }

            
            if(search.regioes && search.regioes != '' && search.regioes != 'Não informado'){
                var regioes = []
                results.forEach(i => {
                    var item = i.regioes.includes(search.regioes)
                    if(item == true){
                        regioes.push(i)
                    }
                })
                results = regioes 
            } 


            // order
             
            var ordem = 'order'
            if(search.order && search.order != ''){
                ordem = search.order
            }

            if(ordem == 'description'){
                return results.sort(function(a, b){
                    if(a.description > b.description) { return 1 }
                    if(a.description < b.description) { return -1 }
                    return 0
                })
            }
    
            if(ordem == 'order'){
                return results.sort((a, b) =>
                    a.order-b.order
                )
            }
            
        }
    },

    formatPrice(value) {
        let val = (value/1).toFixed(2).replace('.', ',')
        return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".")
    },

    converteObjectArrayToString(object){
        let string = '';
        object.forEach((value, index) => {
            if(string != ''){
                string += ', '
            }
            string += value.description
        })
        return string
    },

    converteArrayToString(array){
        let string = '';
        array.forEach(value => {

            if(string != ''){
                string += ', '
            }
            string += value
        })
        return string
    },

    converteStringToArray(value, separator){
        if(!value && value != '') return ''
        return value.split(separator)
    },

    maskPhone(phone){
        var mask = phone.length > 10 ? '(##) #####-####' : '(##) ####-####'
        return mask
    },

    maskCpfCnpj(value) {
        const cleaned = (value || '').toString().replace(/\D/g, '');
        if (cleaned.length <= 11) {
            return '###.###.###-##';   // CPF
        } else {
            return '##.###.###/####-##'; // CNPJ
        }
    },

    userPermission(description){
        if(this.me.profile != 'Master' && this.me.profile != 'Gerente'){
            var result = this.me.permissions.filter(model => model.description == description)
            if(result && result.length > 0){
                return true
            }else{
                return false
            }
        }else{
            return true
        }
    },

    setTotal(item){
        let total = 0
        if(item.valor_locacao && item.valor_locacao > 0){
            total += item.valor_locacao
        }
        if(item.valor_condominio && item.valor_condominio > 0){
            total += item.valor_condominio
        }
        if(item.valor_iptu && item.valor_iptu > 0){
            total += item.valor_iptu
        }
        return total
    },

    filterData(item, queryText) {
        if (!item.all) return false; // Segurança se item.all for undefined
        
        return item.all.toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, "").includes(queryText.toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, ""))
    },

    showSubTipoImovel(item){
        let subtipo = '';
        if(item.sub_tipo_imovel && item.sub_tipo_imovel != 'Apartamento Padrão' && item.sub_tipo_imovel != 'Casa Padrão' && item.sub_tipo_imovel != 'Salão Padrão'){
            subtipo += item.sub_tipo_imovel;
        }

        if(item.em_condominio && item.em_condominio == 'Sim' && item.tipo_imovel != 'Apartamento'){
            subtipo += ' em condomínio';
        }

        return subtipo;                                            
    },


    formatJson(jsonData) {
        const keyMapping = {
            json_property_owners: 'Proprietários',
            json_colaborators: 'Colaboradores',
            json_recreations: 'Recreações',
            json_infrastructures: 'Infraestrutura',
            json_boards: 'Placa',
            json_places: 'Locais',
            json_videos: 'Video',
            json_private_areas: 'Area privativa',
            property_photos: 'Fotos do Imóvel',
        };
      
        // Lista de campos a serem exibidos no caso de `json_property_owners`
        const propertyOwnerFields = [
            'nome', 
            'telefone', 
            'telefone2', 
            'email', 
            'email2', 
            'cpf', 
            'rg',
            'cnpj',
            'inscricao_estadual',
            'como_conheceu',
            'midia',
            'nacionalidade',
            'profissao',
            'cep',
            'endereco',
            'bairro',
            'cidade',
            'estado',
            'numero',
            'complemento',
            'cargo',
            'renda_mensal',
            'faturamento_anual',
            'faturamento_mensal',
            'obs'
        ];
      
        return Object.entries(jsonData)
            .map(([key, value]) => {
                if (key === 'json_property_owners') {
                    // Verifica se o valor é um array antes de iterar
                    if (Array.isArray(value) && value.length > 0) {
                        const formattedOwners = value
                        .map((owner) =>
                            propertyOwnerFields
                            .map((field) => (owner[field] ? `${field.charAt(0).toUpperCase() + field.slice(1)}: ${owner[field]}` : ''))
                            .filter(Boolean) // Remove campos vazios
                            .join(' / ')
                        )
                        .join('\n\n'); // Separar cada proprietário com uma linha em branco
            
                        return `${keyMapping[key]}:\n${formattedOwners}`;
                    } else {
                        // Caso o valor seja null, undefined ou array vazio
                        return `${keyMapping[key]}: Nenhum proprietário cadastrado`;
                    }
                }
        
                // Processar chaves normais
                const formattedKey = keyMapping[key]
                ? keyMapping[key]
                : key.replace(/_/g, ' ').replace(/^\w/, (c) => c.toUpperCase()); // Formatação padrão
        
                return `${formattedKey}: ${value}`;
            })
            .join(' / '); // Junta os itens formatados em linhas
    }
}